import React from 'react'
import VipLayout from '../../../components/vip/VipLayout'

const PrivateDeploymentPage: React.FC = () => {
  return (
    <VipLayout>
      <section className="hero">
        <div className="container">
          <span className="kicker">Private Deployment</span>
          <h1>开源大模型私有化部署解决方案</h1>
          <p>适用于希望基于 Qwen、豆包开源模型、DeepSeek、LLaMA 等开源模型构建企业专属 AI 服务能力的企业客户。</p>
        </div>
      </section>

      <section className="section">
        <div className="container two-col">
          <div>
            <h2 className="section-title">典型适用场景</h2>
            <ul className="list">
              <li>企业知识问答与内部助手</li>
              <li>智能客服与销售辅助</li>
              <li>营销内容生成与知识调用</li>
              <li>行业大模型应用雏形搭建</li>
            </ul>
          </div>
          <div className="card content-card">
            <h3>方案关注点</h3>
            <ul className="list">
              <li>模型选型与商用许可边界</li>
              <li>私有云 / 本地部署方案</li>
              <li>GPU 资源与系统架构</li>
              <li>上线合规与备案前置条件</li>
            </ul>
          </div>
        </div>
      </section>
    </VipLayout>
  )
}

export default PrivateDeploymentPage
